import Api from 'api';

import {
  GET_DEPRECIATIONS,
  SET_DEPRECIATIONS_PAGINATION,
  SET_DEPRECIATIONS_FILTERS,
  RESET_DEPRECIATIONS,
  TOGGLE_DEPRECIATION,
  ADD_DEPRECIATION,
  UPDATE_DEPRECIATION,
  GET_DEPRECIATION_BY_ID,
  RESET_DEPRECIATION_FORM,
  GET_DEPRECIATION_FORM_CONFIG,
  MODIFY_EDITING_DEPRECIATION,
  MODIFY_CUSTOM_FIELD_EDITING_DEPRECATION, //Groups
  ADD_YEAR_EDITING_DEPRECIATION,
  REMOVE_YEAR_EDITING_DEPRECIATION,
} from 'depreciations/constants';

import { SET_LISTS } from 'containers/lists/constants';

export const setPagination = (payload) => ({
  type: SET_DEPRECIATIONS_PAGINATION,
  payload,
});

export const setFilters = (payload) => ({
  type: SET_DEPRECIATIONS_FILTERS,
  payload,
});

export const getDepreciations = (
  companyId,
  subcompanyId,
  filters,
  limit,
  page,
  orderBy,
  order
) => ({
  type: GET_DEPRECIATIONS,
  meta: { needAuth: true },
  payload: Api.depreciations.get(companyId, subcompanyId, filters, limit, page, orderBy, order),
});

export const reset = () => ({ type: RESET_DEPRECIATIONS });

export const toggle = (depreciationId, companyId, subcompanyId) => ({
  type: TOGGLE_DEPRECIATION,
  meta: { id: depreciationId, needAuth: true },
  payload: Api.depreciations.toggle(depreciationId, companyId, subcompanyId),
});

export const resetForm = () => ({ type: RESET_DEPRECIATION_FORM });

export const getDepreciationById = (depreciationId, companyId, subcompanyId) => ({
  type: GET_DEPRECIATION_BY_ID,
  meta: { needAuth: true },
  payload: Api.depreciations.getById(depreciationId, companyId, subcompanyId),
});

export const modifyDepreciation = (payload) => ({ type: MODIFY_EDITING_DEPRECIATION, payload });

//Groups
export const modifyCustomField = (payload) => ({
  type: MODIFY_CUSTOM_FIELD_EDITING_DEPRECATION,
  payload,
}); // Agregado

export const addDepreciation = (companyId, subcompanyId, depreciation) => ({
  type: ADD_DEPRECIATION,
  payload: Api.depreciations.add(companyId, subcompanyId, depreciation),
});

export const updateDepreciation = (depreciationId, companyId, subcompanyId, depreciation) => ({
  type: UPDATE_DEPRECIATION,
  meta: { id: depreciationId, needAuth: true },
  payload: Api.depreciations.update(depreciationId, companyId, subcompanyId, depreciation),
});

export const addYear = () => ({ type: ADD_YEAR_EDITING_DEPRECIATION });

export const removeYear = (index) => ({
  type: REMOVE_YEAR_EDITING_DEPRECIATION,
  payload: index,
});



// WEBPACK FOOTER //
// src/modules/secured/modules/depreciations/actions/depreciations_actions.js